import { useState } from "react";

import './Text.css';

interface Props {
    title: string;
    type?: string;
    value: string;
    setValue: ((value: string) => void) | ((input: string, index: number, value: string) => void);
    input?: string;
    index?: number;
    mask?: (value: string) => string;
    required?: boolean;
    maxLength?: number;
    placeholder?: string;
    readOnly?: boolean;
    className?: string;
}

export default function Comp_Input(props: Props) {

    const [ isFocused, setIsFocused ] = useState(false);

    function ReturnInput(value: string) {
        if (props.readOnly) return;

        if (props.index !== undefined) {
            (props.setValue as (input: string, index: number, value: string) => void)(props.input!, props.index, value);
        } else {
            (props.setValue as (value: string) => void)(value);
        }
    }

    return (
        <div className={ props.className ? "Comp_Input qtd_project" : "Comp_Input" }>
            <div className={ isFocused ? "name_input name_focus" : "name_input" }>
                { props.title }
            </div>
            
            <input
                type={ props.type }
                onChange={ (e) => { ReturnInput(e.target.value) } }
                value={ props.mask ? props.mask(props.value) : props.value }
                required={ props.required ?? false }
                maxLength={ props.maxLength }
                placeholder={ props.placeholder ?? "" }
                onFocus={ () => { setIsFocused(true) } }
                onBlur={ () => { setIsFocused(false) } }
                readOnly={ props.readOnly ?? false }
            />
        </div>
    );
}
